import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { MatStrokedButtonBorderDirective } from 'src/app/shared/directives';
import { CartBillService } from 'src/app/shared/services';
import { AwbComponent } from './awb/awb.component';

@Component({
    standalone: true,
    selector: 'app-lib-awbs-list',
    templateUrl: './awbs-list.component.html',
    imports: [MatButtonModule, AwbComponent, MatStrokedButtonBorderDirective],
})
export class AwbsListComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void> = new Subject<void>();
    public awbs: string[] = [];

    constructor(
        private router: Router,
        private cartService: CartBillService
    ) {}

    ngOnInit(): void {
        this.subscribeCartItems();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeCartItems(): void {
        this.cartService
            .getAWBsFromCart$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (awbs) => {
                    this.awbs = awbs;
                },
            });
    }

    addMoreItems(): void {
        this.router.navigate(['./']);
    }
}
